$(window).on('load', () => {
  let observerConfig = {
    root: null,
    rootMargin: '0px 0px -100px',
    threshold: 0,
  };

  if (window.matchMedia('(min-width:992px)').matches) {
    observerConfig = {
      root: null,
      rootMargin: '0px 0px -100px',
      threshold: 0,
    };
  }

  let previousY = 0;
  let previousRatio = 0;
  // eslint-disable-next-line no-undef
  const observer = new IntersectionObserver(((entries) => {
    entries.forEach((entry) => {
      const currentY = entry.boundingClientRect.y;
      const currentRatio = entry.intersectionRatio;
      const {isIntersecting} = entry;
      const element = entry.target;

      if (isIntersecting === true) {
        element.classList.add('element-seen');
      }

      element.classList.remove('outview-top', 'inview-top', 'inview-bottom', 'outview-bottom');
      // Scrolling up
      if (currentY < previousY) {
        const className = (currentRatio >= previousRatio) ? 'inview-top' : 'outview-top';
        element.classList.add(className);

        // Scrolling down
      } else if (currentY > previousY) {
        const className = (currentRatio <= previousRatio) ? 'outview-bottom' : 'inview-bottom';
        element.classList.add(className);
      }

      previousY = currentY;
      previousRatio = currentRatio;
    });
  }), observerConfig);

  // let elements = document.querySelectorAll('.frame-container');
  // for (let i = 0; i < elements.length; i++) {
  //   observer.observe(elements[i]);
  // }

  setTimeout(() => {
    const elements = document.querySelectorAll(
      '.frame-container'
      + ':not(.frame-container-type-header)'
      + ':not(.frame-container-type-text)'
      + ':not(.frame-container-type-textpic)'
      + ':not(.frame-container-type-image)'
      + ':not(.frame-container-type-mask_hofmann_popup_content)'
      + ',.frame-container-type-header .ce-content'
      + ',.frame-container-type-text .ce-content'
      + ',.frame-container-type-textpic .ce-textpic'
      + ',.frame-container-type-textpic .ce-textpic .ce-gallery-row'
      + ',.frame-container-type-image .ce-image'
      + ',.frame-container-type-mask_hofmann_popup_content .ce-content'
    );
    for (let i = 0; i < elements.length; i += 1) {
      // disable animation in modals
      if ($(elements[i]).parents('.modal').length === 0) {
        observer.observe(elements[i]);
      }
    }
  }, 100);
});
